// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Wyy7","header":"Messages_header__34W40"};